import { initForm } from 'landings/__assets__/scripts/components/form-handling'
import initQrPopup from 'components/qr-popup'
import initExitPopup from 'landings/__assets__/scripts/components/exit-popup'

initForm()
initQrPopup()
initExitPopup({ disableOnMobile: true })
